import React, { lazy } from 'react';
import Loadable from '../../components/Loadable';
import {SalesProvider} from "../../contexts/salesContext/SaleContext";
import {SaleDetailProvider} from "../../contexts/salesContext/SaleDetailContext";

const SaleFragment = Loadable(lazy(() => import('./views/SaleFragment')));
const AddSaleFragment = Loadable(lazy(() => import('./views/AddSaleFragment')));
const SaleDetailFragment = Loadable(lazy(() => import('./views/SaleDetailFragment')));

const saleRoutes = [
    { path: '/sales', element: <SalesProvider><SaleFragment /></SalesProvider> },
    { path: '/add_sale', element: <SalesProvider><AddSaleFragment /></SalesProvider> },
    { path: '/add_sale/:id', element: <SalesProvider><AddSaleFragment /></SalesProvider> },
    { path: '/sale_detail/:id', element: <SaleDetailProvider><SaleDetailFragment /></SaleDetailProvider> },
];

export default saleRoutes;
